import Component from '@glimmer/component';
import { service } from '@ember/service';
import { t, type IntlService } from 'ember-intl';
import { PhChartBar } from 'ember-phosphor-icons';
import ComboChart from 'tio-ui/components/charts/combo-chart';
import BenefitCard from 'tio-employee/components/dashboard-kit/benefit-card';
import {
  TREND_WEEKS,
  type TrendWeek,
} from 'tio-employee/utils/partner-dashboard/sources/ta-analytics';
import type { WidgetComponentSignature } from 'tio-employee/utils/partner-dashboard/registry';

/** Pertinent card: courses submitted vs approved per week; the gap between them is the backlog. */
export default class TaTrendsWidget extends Component<WidgetComponentSignature<TrendWeek[]>> {
  @service declare intl: IntlService;

  get hasActivity() {
    return this.args.data.some((week) => week.submitted || week.approved);
  }

  get labels() {
    // Buckets start at UTC midnight; local formatting would label them with the day before.
    return this.args.data.map((week) =>
      this.intl.formatDate(week.weekStart, { month: 'short', day: 'numeric', timeZone: 'UTC' })
    );
  }

  get series() {
    return [
      {
        label: this.intl.t('partner_dashboard.trends.submitted'),
        data: this.args.data.map((week) => week.submitted),
      },
      {
        label: this.intl.t('partner_dashboard.trends.approved'),
        data: this.args.data.map((week) => week.approved),
      },
    ];
  }

  <template>
    <BenefitCard
      @title={{t "partner_dashboard.trends.title"}}
      @icon={{PhChartBar}}
      data-test-partner-dashboard-ta-trends
    >
      {{#if this.hasActivity}}
        <ComboChart
          @labels={{this.labels}}
          @barSeries={{this.series}}
          @stacked={{false}}
          @height={{220}}
          @showLegend={{true}}
          @legendPosition="bottom"
          @ariaLabel={{t "partner_dashboard.trends.chart_label" weeks=TREND_WEEKS}}
        />
      {{else}}
        <p class="tio-text-sm-medium tio-fg-secondary">
          {{t "partner_dashboard.trends.empty" weeks=TREND_WEEKS}}
        </p>
      {{/if}}
    </BenefitCard>
  </template>
}
